module.exports = __webpack_public_path__ + "img/close.9d48134a.svg";